export enum Platform {
  'MVX'='MVX',
  'MATIC'='MATIC',
}